const refrendaRoutes = [
    {
        path: 'refrenda',
        name: 'refrenda',
        component: () => import(/* webpackChunkName: "refrenda" */ '@/views/acciones-movimientos/v2/refrenda/views/Index.vue'),
    },
    {
        path: 'refrenda/iniciar-proceso',
        name: 'refrenda-iniciar-proceso',
        component: () => import(/* webpackChunkName: "refrenda-iniciar-proceso" */ '@/views/acciones-movimientos/v2/refrenda/views/IniciarProceso.vue'),
    },
    {
        path: 'refrenda/configuracion/:id',
        name: 'refrenda-configuracion',
        component: () => import(/* webpackChunkName: "refrenda-configuracion" */ '@/views/acciones-movimientos/v2/refrenda/views/Steps.vue'),
    },
]

export default refrendaRoutes